<!--
 * @Description: 周材报废审批
 * @Autor: wangwangwang
 * @Date: 2021-05-17 09:55:14
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-08-16 11:40:12
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <div class="flows-details">
                <el-form ref="reffromDate" :model="formData">
                  <el-form-item label="名称：">
                    {{formData.name}}
                  </el-form-item>
                  <el-form-item label="规格：">
                    {{formData.specificationName}}
                  </el-form-item>
                  <el-form-item label="类型：">
                    {{formData.types}}
                  </el-form-item>
                  <el-form-item label="报废数量：">
                    {{formData.amount}}
                  </el-form-item>
                  <el-form-item prop="scrapTime">
                    <span slot="label">报废时间：{{formData.scrapTime}}</span>
                  </el-form-item>
                  <el-form-item prop="scrapType">
                    <span slot="label">报废方式：{{['','变卖','调拨'][formData.scrapType]}}</span>
                  </el-form-item>
                  <el-form-item prop="receivingUnit">
                    <span slot="label">报废单位：{{formData.receivingUnit}}</span>
                  </el-form-item>
                  <el-form-item prop="reason">
                    <span slot="label">报废原因：{{formData.reason}}</span>
                  </el-form-item>
                  <el-form-item prop="remark">
                    <span slot="label">备注：{{formData.remark}}</span>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @handleBusiness="handleBusiness" @sendCode="sendCode" @handleFinish="handleFinish" @submitData="submitDataType" @resetFlowState="resetFlowState" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import { saveOneResord as updateResord } from "@/api/besSer/WMmanagement/scrap";
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '周材报废审批',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      formData: {},
      tableSource: [],
      sendTableSource: [],
      tableNav: [],
      handleList: [],
    }
  },
  methods: {
    submitDataType() {
      if (!this.formData.isAdd) {
        updateResord({
          id: this.formData.id,
          approvalStatus: 1,
        });
      }
    },
    resetFlowState (type) {
      updateResord({
        id: this.formData.id,
        approvalStatus: type===1?2:4,
        approvalStatusSpare: type===1?2:4,
      });
    },
    /**
     * @Description: 组装业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    handleBusiness() {
      const { query } = this.$route;
      const data = JSON.parse(query.dataContent);
      let params = "";
      if (data.isAdd) { // 复检
        params = {
          process_success: {
            url: '/icps/system/sign/goodService/materialsScrap/saveOneResord',
            data: {
              ...this.formData,
              approvalStatus: 3,
              approvalStatusSpare: 3,
            },
            httpMethod: 'post',
          },
          process_failure: ''
        }
      } else { // 异常处理
        params = {
          process_success: {
            url: '/icps/system/sign/goodService/materialsScrap/updateResord',
            data: {
              ...this.formData,
              approvalStatus: 3,
              approvalStatusSpare: 3,
            },
            httpMethod: 'post',
          },
          process_failure: ''
        }
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish() {
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
        this.showSendVisible = true;
        return
      }
      const params = {
        dataSource: 'materialScrap',
        dataContent: JSON.stringify({ ...this.formData}), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, params);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode();
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    initFlowsData(data) {
      this.formData = data;
    },
    initFlowsData2() {
      const { query } = this.$route;
      this.formData = JSON.parse(query.dataContent);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      this.applyPerson = query.createUserName;
      this.taskStatus = query.taskStatus;
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      this.initFlowsData(query);
      this.$refs.flowcontent.initBaseData('materialScrap');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.applyPerson = getUserInfo().userRealName;
      return
    }
    this.initFlowsData2();
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
</style>

